import React, { Component } from 'react'

const styles = {
  link: {
    whiteSpace: 'nowrap',
    cursor: 'pointer',
    fontSize: '12px',
    fontWeight: '700',
    WebkitFontSmoothing: 'antialiased',
    MozSmoothing: 'antialiased',
    color: '#26334D',
    letterSpacing: '1px',
    margin: '0 5px',
    textTransform: 'initial',
    textDecoration: 'underline'
  },
  linkButton: {
    whiteSpace: 'nowrap',
    cursor: 'pointer',
    fontSize: '12px',
    fontWeight: '700',
    WebkitFontSmoothing: 'antialiased',
    MozSmoothing: 'antialiased',
    margin: '0 5px',
    padding: '8px 15px',
    borderRadius: '30px',
    lineHeight: '30px',
    color: '#FFF',
    background: '#26334D',
    letterSpacing: '1px',
    textTransform: 'uppercase'
  }
}

export class Link extends Component {
  render () {
    const linkStyle = { ...styles.link, ...this.props.style }
    return (
      <a href={this.props.href} style={linkStyle}>
        {this.props.children}
      </a>
    )
  }
}

export class LinkButton extends Component {
  render () {
    return <button style={styles.linkButton}>{this.props.children}</button>
  }
}
